import React, { useEffect, useState } from "react";
import requests from "../Request";
import axios from "../axios";
import "./Banner.css";

function Banner() {

    const [movie, setMovie] = useState([])


    useEffect(()=>{
        async function fetchData(){
         const request = await axios.get(requests.fetchNetflixOriginals);

         setMovie(
            request.data.results[
                Math.floor(Math.random() * request.data.results.length - 1)
            ]
         );
         return request;
        }
        fetchData()
    },[])
    
  function trancate(string, n) {
    return string?.length > n ? string.substr(0, n - 1) + "..." : string;
  }
  return (
    <header
      className="banner"
      style={{
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundImage: `url('https://image.tmdb.org/t/p/original/${movie?.backdrop_path}')`,
      }}
    >
      <div className="banner__contents">
        <h1 className="banner__title">{movie?.name}</h1>
        {/* || {movie?.original_name} */}
        <div className="banner__buttons">
          <button className="banner__button">Play</button>
          <button className="banner__button">My list</button>
        </div>
        <h1 className="banner__description">
          {trancate(movie?.overview,
            150
          )}
        </h1>
      </div>
      <div className="banner--fadeBottom" />
    </header>
  );
}

export default Banner;
